'use client';

import { Stack, Text } from '@backyard-ui/core';

import { useProductStore } from '@/presenters/store/catalog/product';

import { VariantsCarousel } from './VariantsCarousel';

type VariantsProps = {
  itemId: number;
};

function Variants(props: Readonly<VariantsProps>) {
  const { itemId } = props;
  const variants = useProductStore((store) => store.variants);

  return (
    <>
      {variants.map(({ name, types }, index) => {
        const selectedVariantType =
          types.find((type) => type.id === itemId) || types[0];
        const selectedVariantLabel = selectedVariantType.label;

        return (
          <Stack spacing="2" direction="column" key={index} className="w-full">
            <Stack spacing="2">
              <Text size="md" asChild>
                <strong className="font-semibold">{name}: </strong>
              </Text>
              <Text size="md" asChild>
                <span data-testid="selected-variant-label">
                  {selectedVariantLabel}
                </span>
              </Text>
            </Stack>

            <VariantsCarousel types={types} selectedId={itemId} />
          </Stack>
        );
      })}
    </>
  );
}

export default Variants;
